import { ArrowPathIcon } from "@heroicons/react/24/outline";

export default function Content({ pageErrorTypes, pageError, refresh = () => {} }) {
  return (
    <div className="relative flex w-full items-center justify-center overflow-hidden px-6 py-12">
      <div className="relative z-10 w-full max-w-xl rounded-2xl  p-10">
        <div className="space-y-3 text-center">
          <h1 className="text-3xl font-bold leading-tight text-gray-500">
            <span className="text-gray-500">{pageErrorTypes[pageError].title}</span>
          </h1>

          <p className="mx-auto max-w-lg text-lg leading-relaxed text-gray-600">{pageErrorTypes[pageError].subtitle}</p>

          <div className="flex items-center justify-center space-x-2 text-sm text-gray-500">
            <span>{pageErrorTypes[pageError].secondary}</span>
          </div>
        </div>

        <div className="mt-6 flex justify-center">
          <button
            onClick={refresh}
            className="group relative inline-flex transform items-center rounded-xl bg-gray-300/50 px-8 py-4 text-base font-semibold text-gray-500 transition-all duration-300 hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-gray-500/50 focus:ring-offset-2 focus:ring-offset-transparent">
            <div className="relative flex items-center">
              <ArrowPathIcon className="mr-2 h-6 w-6 stroke-gray-400" />
              Retry
            </div>
          </button>
        </div>
      </div>
    </div>
  );
}
